"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkLinkErrorCode = exports.retry = exports.removeRequest = exports.setRequest = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    requests: {},
    retry: false,
};
const networkLinkSlice = toolkit_1.createSlice({
    name: 'networkLink',
    initialState,
    reducers: {
        setRequest(state, { payload }) {
            state.requests[payload.traceId] = payload;
        },
        removeRequest(state, { payload }) {
            if (state.requests[payload.traceId]) {
                delete state.requests[payload.traceId];
            }
        },
        retry(state) {
            state.retry = !state.retry;
        },
    },
});
const { actions, reducer } = networkLinkSlice;
exports.setRequest = actions.setRequest, exports.removeRequest = actions.removeRequest, exports.retry = actions.retry;
exports.default = reducer;
exports.NetworkLinkErrorCode = {
    NetworkError: 0,
    ServerError: 1,
};
